"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionReducerMap = exports.dealershipChangedAction = exports.DEALERSHIP_CHANGED = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var _lifecycle = require("../lifecycle.reducer");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var postfix = "/".concat(_lifecycle.lifecycleReducer.sliceName, "/app");
var DEALERSHIP_CHANGED = "DEALERSHIP_CHANGED".concat(postfix);
exports.DEALERSHIP_CHANGED = DEALERSHIP_CHANGED;
var dealershipChangedAction = (0, _reduxUtils.createAction)(DEALERSHIP_CHANGED);
exports.dealershipChangedAction = dealershipChangedAction;

var actionReducerMap = _defineProperty({}, DEALERSHIP_CHANGED, function (slice, action) {
  // console.log(action.type, action.payload); // eslint-disable-line no-console
  return _objectSpread({}, slice, {
    dealershipId: action.payload.dealershipId,
    releasePool: action.payload.releasePool
  });
});

exports.actionReducerMap = actionReducerMap;

_lifecycle.lifecycleReducer.addActionReducerMap(actionReducerMap);